import { MARK_RTO_RECEIVED_FAILURE, MARK_RTO_RECEIVED_REQUEST, MARK_RTO_RECEIVED_SUCCESS } from "../../actions";
const initialState = {
    data: null,
    result: null,
    loading: false,
    error: null,
};
const markRtoReceivedDetailsReducer = (state = initialState, action) => {
    switch (action.type) {
        case MARK_RTO_RECEIVED_SUCCESS:
            return Object.assign(Object.assign({}, state), { loading: false, error: null, result: action.payload });
        case MARK_RTO_RECEIVED_REQUEST:
            return Object.assign(Object.assign({}, state), { loading: false, data: action.payload, error: null });
        case MARK_RTO_RECEIVED_FAILURE:
            return Object.assign(Object.assign({}, state), { loading: false, error: action.payload });
        default:
            return state;
    }
};
export default markRtoReceivedDetailsReducer;
